import TopicTwo from "../../resource-contents/currency-converter-contents/TopicTwo";

const CurrencyConverterContentFour = () => {
  return (
    <>
      {/* <TopicTwo /> */}

      <div className="how__work__resource">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Your Trusted Currency Companion</h1>
            <p>
              Built for traders, travelers, and investors who rely on real-time
              accuracy.
            </p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Global Market Integration</h4>
                </div>
                <p>
                  Our rates are directly linked to international financial feeds
                  for unmatched accuracy.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Multi-Device Access</h4>
                </div>
                <p>
                  Seamlessly check conversions across desktop, tablet, or
                  mobile, anytime, anywhere.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Updated Continuously</h4>
                </div>
                <p>
                  Rates refresh multiple times per minute to reflect live market
                  activity
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CurrencyConverterContentFour;
